import { put, call } from 'redux-saga/effects';
import { LoginAction,UIAction, DashboardAction } from '../actions';
import { LoginService } from '../services';
import { generateReadableError,setOtpKey,setToken,clearStorage,setLoginData } from 'hooks';

export function* tryLogin(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(LoginService.getInstance().tryLogin, action.payload);
    if(data && data.key){
      setOtpKey(data.key);
      yield put(LoginAction.loginSuccess(data));
      yield put(UIAction.showMessages({status:'success',message:data.responseMessage}));
    }else{
      clearStorage();
      yield put(LoginAction.loginSuccess(null));
      yield put(UIAction.showMessages({status:'danger',message:data.responseMessage}));
    }
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* getLoginData(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(LoginService.getInstance().fetchLoginData, action.payload);
    if(data && data.user){
      setLoginData(JSON.stringify(data.user));
      yield put(LoginAction.verifyOtpSuccess(data));
      yield put(DashboardAction.saveDashboardWidgetSuccess((data.widget && data.widget.length >0)?JSON.parse(data.widget):[]));
    }else{
      clearStorage();
      yield put(UIAction.showMessages({status:'danger',message:data.responseMessage}));
    }
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* changePassword(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(LoginService.getInstance().changePassword, action.payload);
    yield put(LoginAction.changePasswordSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* resetPassword(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(LoginService.getInstance().resetPassword, action.payload);
    yield put(LoginAction.resetPasswordSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* verifyOtp(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(LoginService.getInstance().verifyOtp, action.payload);
    if(data && data.user && data.user.api_token){
      setToken(data.user.api_token);
      setLoginData(JSON.stringify(data.user));
      yield put(LoginAction.verifyOtpSuccess(data));
      yield put(DashboardAction.saveDashboardWidgetSuccess((data.widget && data.widget.length >0)?JSON.parse(data.widget):[]));
    }else{
      yield put(UIAction.showMessages({status:'danger',message:data.responseMessage}));
    }
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    console.log(e)
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


